"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListingBookmarkListModel_1 = require("./ListingBookmarkListModel");
var ListingBookmarkListStore = new ListingBookmarkListModel_1.ListingBookmarkListModel();
exports.ListingBookmarkListStore = ListingBookmarkListStore;
